import cn from 'clsx'

import s from './Intro.module.sass'

function Intro({ project, icon }: any) {
    const { location, scale, year, showNa, nabersRating, excerpt } = project

    return (
        <section className={s.Intro}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Info}>
                    {location && (
                        <div>
                            <div>
                                <div className={s.Icon}>{icon}</div>
                                <span
                                    className="smallCaps"
                                    data-title="Location"
                                    dangerouslySetInnerHTML={{
                                        __html: location,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {scale && (
                        <div>
                            <div>
                                <div className={s.Icon}>{icon}</div>
                                <span
                                    className="smallCaps"
                                    data-title="Scale"
                                    dangerouslySetInnerHTML={{
                                        __html: scale,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {year ? (
                        <div>
                            <div>
                                <div className={s.Icon}>{icon}</div>
                                <span
                                    className="smallCaps"
                                    data-title="Year"
                                    dangerouslySetInnerHTML={{
                                        __html: year,
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}
                    {showNa && !year ? (
                        <div>
                            <div>
                                <div className={s.Icon}>{icon}</div>
                                <span
                                    className="smallCaps"
                                    data-title="Year"
                                    dangerouslySetInnerHTML={{
                                        __html: 'N/A',
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}
                    {nabersRating && (
                        <div>
                            <div>
                                <div className={s.Icon}>{icon}</div>
                                <span
                                    className="smallCaps"
                                    data-title="NABERS Rating"
                                    dangerouslySetInnerHTML={{
                                        __html: nabersRating,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className={s.Excerpt}>
                    {excerpt && (
                        <h3
                            dangerouslySetInnerHTML={{
                                __html: excerpt,
                            }}
                        />
                    )}
                </div>
            </div>
        </section>
    )
}

export default Intro
